import React, {ReactElement, useState} from "react"
import classNames from "classnames"
import {Button} from "antd"
import {observer} from "mobx-react-lite"
import {t} from "@ui/common/intl"
import {useStore} from "@ui/stores"
import RecordingIcon from "@ui/icons/track/Recording"
import StopIcon from "@ui/icons/track/Stop"
import PoolModal from "@ui/components/common/PoolModal"
import {TrackPage, TTrackPageProps} from "./"

type TNoPointsModalProps = {
  back: () => void,
  close: () => void,
  isShow: boolean
}

const NoPointsModal = ({isShow, close, back}: TNoPointsModalProps) => {
  return (
    <PoolModal
      open={isShow}
      closable={false}
      title={
        <div className="centered">
          <span>{t("track.save.modal.deny.title")}</span>
        </div>
      }
      width=""
      centered={true}
      footer={
        <div className="buttons">
          <Button
            className="button-primary"
            onClick={back}>
            {t("button.back")}
          </Button>
          <Button
            className="button-regular"
            onClick={close}
          >
            {t("button.not.save")}
          </Button>
        </div>
      }
    >
      {t("track.save.route.dialog.no.points.error")}
    </PoolModal>
  )
}

export const MinimizedRecord = ({open, goto, param}: TTrackPageProps): ReactElement => {
  const {track, settings} = useStore()
  const [noPoints, setNoPoints] = useState(false)

  const handleComplete = () => {
		if (track.isSaveAvailable) {
      track.switchRecording()
      goto(TrackPage.Save)
      open()
    } else {
      setNoPoints(true)
    }
  }

	return (
		<div className={classNames("dialog", "record", "minimized")}>
			<div className="title">
				<RecordingIcon className="animate"/>
				<span className="secondary-header-text">{t("track.recording.title")}</span>
			</div>
      {!settings.isMobile && !param &&
        <div className="buttons">
          <Button
            icon={<StopIcon />}
            onClick={handleComplete}
            className={classNames("complete", "button-primary")}
          >
            {t("button.complete")}
          </Button>
        </div>
      }
      <NoPointsModal
        back={() => setNoPoints(false)}
        close={() => {
          track.switchRecording()
          goto(TrackPage.List)
          open()
        }}
        isShow={noPoints}
      />
		</div>
	)
}

const Record = ({goto, close}: TTrackPageProps): ReactElement => {
	const {track} = useStore()
  const [noPoints, setNoPoints] = useState(false)

	const handleComplete = () => {
		if (track.isSaveAvailable) {
      track.switchRecording()
      goto(TrackPage.Save)
    } else {
      setNoPoints(true)
    }
	}

	return (
		<div className="record">
			<div className="title">
				<RecordingIcon className="animate"/>
				<span className="secondary-header-text">{t("track.recording.title")}</span>
			</div>
			<div className="buttons">
				<Button
          icon={<StopIcon />}
					onClick={handleComplete}
					className={classNames("complete", "button-primary")}
				>
					{t("button.complete")}
				</Button>
				<Button className="minimize button-regular" onClick={close}>
					{t("button.minimize")}
				</Button>
			</div>
      <NoPointsModal
        back={() => setNoPoints(false)}
        close={() => {
          track.switchRecording()
          goto(TrackPage.List)
        }}
        isShow={noPoints}
      />
		</div>
	)
}

export default observer(Record)
